module.exports = __webpack_public_path__ + "static/media/closePrimary.b2439fe6.svg";